import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { normalizeRole } from './permissions';
import { fetchBrandAccess } from '@/services/brandWork';
import type { SessionUser } from '@/lib/session';

export function canRequestBrandAccess(user?: Pick<SessionUser, 'id' | 'role' | 'isInternal'> | null): boolean {
  return Boolean(user?.id && user.isInternal !== false &&
    !['CLIENTE', 'CONSULTA', 'CONSULTOR_SAI', 'PROVEEDOR'].includes(normalizeRole(user.role)));
}

export function useBrandWorkAccess() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['brand-work', 'me', user?.id, user?.role, user?.isInternal],
    queryFn: fetchBrandAccess,
    enabled: canRequestBrandAccess(user),
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
